import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";

export const getAllTypes = (config?: AxiosRequestConfig, showSpinner = false): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/type/all`, { withCredentials: true, ...config }, showSpinner);
};

export const getTypeByKey = (boKey: string, showSpinner: boolean, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `type/key/${boKey}`, { ...config }, showSpinner);
};

export const getTypeById = (id: number, showSpinner: boolean, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `type/${id}`, { ...config }, showSpinner);
};
